import Hook from "../../utils/hook"
import { scrollIntoView } from "../../utils/scroll"

export const GuidePage = Hook(`GuidePage`, {
  refs: [`map`],

  mapRefMounted(mapRef) {
    mapRef.addReceiveHandler(this.mapReceive.bind(this))
  },

  mapReceive(message) {
    switch (message.method) {
      case `loaded`: {
        if (this.mapRef && window.location.hash == `#${this.mapRef.el.id}`)
          this.enterMapFullscreen()
        break
      }

      case `setQuery`: {
        this.mapQueryWasSet(message.data)
        break
      }
    }
  },

  enterMapFullscreen() {
    return new Promise((resolve) => {
      if (!this.mapRef) return

      scrollIntoView(this.mapRef.el, { block: `center` }).then(() => {
        if (this.mapRef) this.mapRef.setFullscreen(true).then(resolve)
      })
    })
  },

  goToMapAction(e) {
    if (!this.mapRef) return
    e.preventDefault()
    e.stopImmediatePropagation()

    window.history.replaceState(null, null, `#${this.mapRef.el.id}`)

    const query = e.currentTarget.dataset.query
    this.enterMapFullscreen().then(() => {
      if (this.mapRef) this.mapRef.setQueryWithDefault(query)
    })
  },

  mapQueryWasSet(query) {
    if (!this.mapRef) return

    const urlTypes = this.mapRef.el.dataset.urlTypes.split(`,`)
    const params = {}

    query.forEach((q) => {
      if (urlTypes.includes(q.type)) {
        params[q.type] = params[q.type] || []
        params[q.type].push(q.value)
      }
    })

    let url = Object.entries(params)
      .map(([k, v]) => `${k}=${v.join(`,`)}`)
      .join(`&`)

    url = url ? `?${url}` : ``
    if (this.mapRef.el.id) url += `#${this.mapRef.el.id}`

    window.history.replaceState(null, null, url)
  },
})

export const GuidePageHeroCategories = Hook(`GuidePageHeroCategories`, {
  refs: [`carousel`],
  targets: [`navPrev`, `navNext`],
  actions: [
    {
      target: `navPrev`,
      name: `scrollPrev`,
      type: `click`,
    },
    {
      target: `navNext`,
      name: `scrollNext`,
      type: `click`,
    },
  ],

  carouselRefMounted(carouselRef) {
    carouselRef.addScrollEndHandler(this.scrollEnded.bind(this))
    this.scrollEnded()
  },

  scrollNextAction() {
    if (this.carouselRef) this.carouselRef.scrollNext()
  },

  scrollPrevAction() {
    if (this.carouselRef) this.carouselRef.scrollPrev()
  },

  scrollEnded() {
    if (!this.carouselRef) return

    this.navPrevTarget.disabled = false
    this.navNextTarget.disabled = false

    if (this.carouselRef.isBeginning()) this.navPrevTarget.disabled = true
    if (this.carouselRef.isEnd()) this.navNextTarget.disabled = true
  },
})
